import { useInsiderState } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderState";

export const useShowEligibleInsiderMessaging = () => {
  const { isInsiderEligible, isInsiderCancelled } = useInsiderState();
  const showEligibleInsiderMessaging = isInsiderEligible || isInsiderCancelled;

  return { showEligibleInsiderMessaging };
};
